var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleCallingVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 14.4284V14.9846L24.7549 13.6908C25.009 13.5638 25.2912 13.5039 25.5749 13.5167C25.8586 13.5294 26.1343 13.6145 26.3759 13.7638C26.6175 13.913 26.817 14.1215 26.9553 14.3695C27.0937 14.6175 27.1664 14.8972 27.1666 15.1812V20.8183C27.1664 21.1023 27.0937 21.3815 26.9553 21.6295C26.817 21.8775 26.6175 22.086 26.3759 22.2353C26.1343 22.3846 25.8586 22.4696 25.5749 22.4824C25.2912 22.4952 25.0088 22.4352 24.7548 22.3083L22.1666 21.0144V21.5713C22.1666 22.8859 21.0288 23.8332 19.7777 23.8332H11.2221C9.97102 23.8332 8.83325 22.8859 8.83325 21.5713V14.4284C8.83325 13.1138 9.97102 12.1665 11.2221 12.1665H19.7777C21.0288 12.1665 22.1666 13.1138 22.1666 14.4284Z",
    fill: "#1E2131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCallingVideoCall);
export default __webpack_public_path__ + "static/media/people-calling-video-call.eb6eed3487f5413c8ab10076efee9e5c.svg";
export { ForwardRef as ReactComponent };